
import icon from 'assets/img/icons/success-green-big.svg'

const RedeemPrizeSuccess = ({close}) => {
  return (
    <>
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Success!</h5>
        <p className="modal-window__info">Your Prize Card was Redeemed!</p>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-close" onClick={close}>Done</button>
      </footer>
    </>
  )
}

export default RedeemPrizeSuccess;
